import {
  checkHttpStatus,
  getApiBaseUrlWithOrg,
  getApiHeadersFromToken
} from '../../../utils/api'

// All of these functions are .bind()ed to the component in ../UpdateTargetDate.js,
// hence the this.props references

export const fetchUserQuestAssessments = async function () {
  const {
    token,
    orgId,
    quest
  } = this.props

  let url = `${getApiBaseUrlWithOrg(orgId)}/compiled_quests/${quest.published_compiled_quest_id}`

  try {
    const response = checkHttpStatus(await fetch(url, {
      method: 'GET',
      headers: getApiHeadersFromToken(token)
    }))

    const data = await response.json()

    this.setState({
      activities: data.compiled_quest.document.activities.filter(activity => activity.work_product)
    })
  }
  catch (e) {
    // TODO error logging
  }
}
